/* global globalThis */
import url from './apiURL';
import { authenticatedFetch } from "../../utils/authenticatedFetch";
import { getValidToken } from "../../utils/getValidToken";

export const fetchHighRiskSKUData = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchSuggestedHighRiskSKUData, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

export const fetchSuggestedKPIs = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchSuggestedKPIs, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

export const fetchDCwiseSuggested = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchSuggestedDCwiseSuggested, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

export const fetchSuggestedOrderFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchSuggestedOrderFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

export const fetchSuggestedOrderOverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchSuggestedOrderOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};


export const fetchDispatchPriorityMinMaxGraph = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchDispatchPriorityMinMaxGraph, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching dispatch priority min max graph:', error);
        throw error;
    }
};

export const fetchDispatchPriorityKPI = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchDispatchPriorityKPI, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching dispatch priority KPI:', error);
        throw error;
    }
};

export const fetchDispatchFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchDispatchPriorityFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching dispatch filters:', error);
        throw error;
    }
};

export const fetchDispatchOverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchDispatchPriorityOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching dispatch overview table:', error);
        throw error;
    }
};

export const fetchDCwisePrioritizationSuggested = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchDispatchDCwisePriorityGoodenessGraph, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching dispatch overview table:', error);
        throw error;
    }
};

export const fetchGoodnessGraph = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchDispatchPriorityGoodenessGraph, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching goodness graph:', error);
        throw error;
    }
};

export const handleOverviewDispatchExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.exportDispatchPrioOverview, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        console.log("Export response:", response);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        const currentDate = new Date().toISOString().split('T')[0];
        link.setAttribute("download", `Dispatch_Priority_${payload.uom}_${currentDate}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error exporting dispatch priority data:', error);
        throw error;
    }
};

export const handleAllDispatchPriorityExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.parentDispatchPrioExport, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        const currentDate = new Date().toISOString().split('T')[0];
        link.setAttribute("download", `Dispatch_Priority_${payload.uom}_${currentDate}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error exporting all dispatch priority data:', error);
        throw error;
    }
};

export const handleHighRiskSkuExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.exportSuggestedHighRiskSkus, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        const currentDate = new Date().toISOString().split('T')[0];
        link.setAttribute("download", `High_Risk_SKU_${payload.uom}_${currentDate}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

export const handleSuggestedOrderOverviewExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.exportSuggestedOrderOverview, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        link.setAttribute("download", `Suggested_Order_Overview_${payload.uom}_${new Date().toISOString().split('T')[0]}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

export const fetchCustomerBucketCount = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchDispatchPriorityCustomerBucketCount, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching goodness graph:', error);
        throw error;
    }
};

export const handleAllSuggestedOrderExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.parentSuggestedOrderExport, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        const currentDate = new Date().toISOString().split('T')[0];
        link.setAttribute("download", `Suggested_Order_${payload.uom}_${currentDate}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

export const fetchPoPriorityFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchPOPriorityFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching PO priority filters:', error);
        throw error;
    }
};

export const fetchPOValidityBuckets = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchPOValidityBuckets, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching PO validity buckets:', error);
        throw error;
    }
};

export const fetchPOPriorityOverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchPOPriorityOverview, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching PO priority overview:', error);
        throw error;
    }
};

export const fetchCustomerLevelPOWisePriorityStatus = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchCustomerLevelPOWisePriorityStatus, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching customer level PO wise priority status:', error);
        throw error;
    }
};

export const fetchDCLevelPOWisePriorityStatus = async (payload) => {
    try {
        return await authenticatedFetch(url.fetchDCLevelPOWisePriorityStatus, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching DC level PO wise priority status:', error);
        throw error;
    }
};

export const handleExportPOPriorityOverview = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.exportPOPriorityOverview, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        const currentDate = new Date().toISOString().split('T')[0];
        link.setAttribute("download", `PO_Priority_Overview_${currentDate}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching PO priority overview data:', error);
        throw error;
    }
};

export const handleExportPOPriorityWholeScreen = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.exportPOPriorityWholeScreen, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        const currentDate = new Date().toISOString().split('T')[0];
        link.setAttribute("download", `PO_Priority_${currentDate}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching PO priority data:', error);
        throw error;
    }
};